import { render, staticRenderFns } from "./loginMenu.vue?vue&type=template&id=161dc106&scoped=true"
import script from "./loginMenu.vue?vue&type=script&lang=js"
export * from "./loginMenu.vue?vue&type=script&lang=js"
import style0 from "./loginMenu.vue?vue&type=style&index=0&id=161dc106&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161dc106",
  null
  
)

export default component.exports